import React from 'react';
import { Label, Popup, List } from 'semantic-ui-react';

const TagLegends = ({ trigger }) => (
  <Popup
    wide="very"
    content={(
      <List>
        <List.Item>
          <Label color="brown" size="small" style={{ width: '70px', textAlign: 'center' }}>Expertise</Label>
          {' supported by past Dexter projects'}
        </List.Item>
        <List.Item>
          <Label color="yellow" size="small" style={{ width: '70px', textAlign: 'center' }}>Match</Label>
          {' tag provided by expert and matches your search'}
        </List.Item>
        <List.Item>
          <Label size="small" style={{ width: '70px', textAlign: 'center' }}>Tag</Label>
          {' other tags provided by expert'}
        </List.Item>
      </List>
    )}
    trigger={trigger}
  />
);

const Tags = ({ expert, searchData }) => {
  const highlightedExpertiseTags = searchData?.highlights.find((h) => h.field === 'expertise')?.segments.map((h) => h.replace(/<\/?em>/g, '')) || [];
  const highlightedExpertTags = searchData?.highlights.find((h) => h.field === 'tags')?.segments.map((h) => h.replace(/<\/?em>/g, '')) || [];

  const uniqueExpertTags = Array.from(new Set([...expert.medical_specialties, ...expert.functions,
    ...expert.technology_tags, expert.organization.type].filter((x) => x)));

  // Add expertise tags which have not already been in self-supplied tags
  const additionalExpertiseTags = highlightedExpertiseTags.filter(
    (et) => !uniqueExpertTags.some((ut) => ut.toLowerCase() === et.toLowerCase()),
  );
  const tags = uniqueExpertTags.concat(additionalExpertiseTags);

  if (tags.length === 0) return <div />;

  const isHighlightedExpertiseTag = (tag) => highlightedExpertiseTags.some(
    (et) => et.toLowerCase() === tag.toLowerCase(),
  );

  const isHighlightedExpertTag = (tag) => highlightedExpertTags.some(
    (et) => et.toLowerCase() === tag.toLowerCase(),
  );

  const renderTag = (tag) => {
    if (isHighlightedExpertiseTag(tag)) {
      return (
        <TagLegends key={tag} trigger={(<Label size="small" color="brown">{tag}</Label>)} />
      );
    }
    if (isHighlightedExpertTag(tag)) {
      return <TagLegends key={tag} trigger={(<Label size="small" color="yellow">{tag}</Label>)} />;
    }
    return <TagLegends key={tag} trigger={(<Label key={tag} size="small">{tag}</Label>)} />;
  };

  tags.sort((a, b) => {
    const getScore = (tag) => {
      if (isHighlightedExpertiseTag(tag)) return 2;
      if (isHighlightedExpertTag(tag)) return 1;
      return 0;
    };
    return getScore(b) - getScore(a);
  });

  return (
    <div className="tags-section">
      {tags.slice(0, 6).map((t) => renderTag(t))}
    </div>
  );
};

export default Tags;
